import {BreadcrumbStructuredData} from './breadcrumb';
import {OrganizationStructuredData} from './organization';
import {WebpageStructuredData} from './webpage';
import type {FunctionComponent} from 'react';

type StructuredDataProps = {
	description: string | undefined;
	withBreadCrumbStructuredData: boolean | undefined;
};

export const StructuredData: FunctionComponent<StructuredDataProps> = ({
	description = '',
	withBreadCrumbStructuredData = true,
}) => {
	return (
		<>
			{withBreadCrumbStructuredData && <BreadcrumbStructuredData />}
			<OrganizationStructuredData />
			<WebpageStructuredData description={description} />
		</>
	);
};
